import { Api } from '@/utils';
import { getTreeData, filterShowTreeData, formatShowTreeData, extendShowTreeData } from './utils';
import { postRecordList } from './../filterTree/service';

export const getHighlightMaterial = async (cpartCode: string, demoType: string) => {
  const mainRes = await postRecordList({
    app_id: 'tp',
    model_id: 'isc_npi_demo_test_purchase_basic_info',
    cpart_code: cpartCode,
    demo_type: demoType,
  });
  const mainData = mainRes?.data[0] || {};
  const mainId = mainData.isc_npi_demo_test_purchase_basic_info_id;
  // TODO 判断内部打样还是外部打样 isc_npi_demo_test_inner_purchase_content内部 isc_npi_demo_test_out_purchase_content外部
  const listRes = await postRecordList({
    app_id: 'tp',
    model_id: 'isc_npi_demo_test_inner_purchase_content',
    isc_npi_demo_test_purchase_basic_info_id: mainId,
  });
  console.log('isc_npi_demo_test_inner_purchase_content', listRes?.data);
  const materialCodes = (listRes?.data || []).map((el: any) => el.material_code);
  const materialRes = await postRecordList({
    app_id: 'master_data',
    model_id: 'md_material_base_info',
    material_code: materialCodes,
    conditionType: 'in',
  });
  const materialList = (materialRes?.data || []).filter((item: any, index: any, selfArr: any) => {
    return selfArr.findIndex((x: any) => x.material_code === item.material_code) === index;
  });
  const materialData = materialList.map((el: any) => {
    return {
      material_class_code: el.material_class_code,
      material_num: el.material_code,
      material_save_name: el.material_name,
      isHighlight: true,
      data_source: el.data_source,
      cparts_code: cpartCode,
    };
  });
  return materialData;
};

export const getShowTreeData = async (mainData: any, productCode: string, cpartCode: string, demoType: string) => {
  const productRes = await postRecordList({
    app_id: 'base',
    model_id: 'bd_bpart_product_classification',
    number: productCode,
  });
  const newProductName = productRes?.data[0]?.name;
  const number = mainData?.number;
  const listRes = await postRecordList({
    app_id: 'master_data',
    model_id: 'md_bbom_template_line',
    md_bbom_template_number: number,
  });
  const list = (listRes.data || []).filter((el: any) => !el.is_bpart_classification);
  const treeRes = await postRecordList({
    app_id: 'base',
    model_id: 'bd_material_classification',
  });
  const bpartData = await postRecordList({
    app_id: 'base',
    model_id: 'bd_bpart_product_classification',
    number: productCode,
  });
  const allList = treeRes.data.map((el: any) => {
    const idItem = list.find((item: any) => item.bd_material_classification_number === el.number);
    return {
      ...(idItem || {}),
      ...el,
      key: el.number,
      title: el.name,
      disabled: !idItem?.md_bbom_template_line_id,
    };
  });
  const newTreeData = getTreeData(allList, 'superior_number', 'number');
  const topLineItem = (listRes.data || []).find((el: any) => el.bd_material_classification_number === productCode && el.is_bpart_classification === 'true');
  const allData = {
    ...mainData,
    ...(topLineItem || {}),
    cpartCode,
    title: newProductName,
    key: productCode + 'true',
    number: productCode,
    product_type: bpartData?.data?.[0]?.product_type,
    disabled: !topLineItem,
    isProduct: true,
    children: newTreeData,
  };
  const keys = list.map((el: any) => el.bd_material_classification_number);
  // 高亮物料
  let highlightMaterialData: any[] = [];
  if (demoType) {
    highlightMaterialData = await getHighlightMaterial(cpartCode, demoType);
  }
  const highlightMaterial = highlightMaterialData.map((el: any) => el.material_num);
  const materialRes = await postRecordList({
    app_id: 'tp',
    model_id: 'isc_npi_demand_design_material_delivery_bo',
    cparts_code: cpartCode,
  });
  // 备选物料
  const materialList = (materialRes?.data || []).filter((item: any, index: any, selfArr: any) => {
    return selfArr.findIndex((x: any) => x.material_code === item.material_code) === index;
  });
  const materialListCodes = materialList.map((el: any) => el.material_code);
  const materialListData = materialList.map((el: any) => {
    return {
      ...el,
      isHighlight: highlightMaterial.includes(el.material_code),
      data_source: highlightMaterialData.find((item: any) => item.material_num === el.material_code)?.data_source,
      material_num: el.material_code,
    };
  });
  const excessMaterial = highlightMaterialData.filter((el: any) => !materialListCodes.includes(el.material_num));
  const allMaterialListData = materialListData.concat(excessMaterial);
  const materialSourceRes = await postRecordList({
    app_id: 'master_data',
    model_id: 'md_material_base_info',
    material_code: allMaterialListData.map((el: any) => el.material_num),
    conditionType: 'in',
  });
  const materialSourceList = (materialSourceRes?.data || []);
  allMaterialListData.forEach((el: any) => {
    const itemData = materialSourceList?.find((item: any) => item.material_code === el.material_num);
    el.data_source = itemData?.data_source;
    el.product_type = itemData?.product_type;
    el.material_save_name = itemData?.material_name;
    el.material_class_code = itemData?.material_class_code;
  });
  console.log('materialListData', materialListData, highlightMaterialData, excessMaterial, allMaterialListData, allData, keys);
  const extendNewData = extendShowTreeData(allData, allMaterialListData);
  const allMaterialListCode = allMaterialListData.map((el: any) => el.material_num);
  const allKeys = keys.concat(allMaterialListCode);
  const newData = filterShowTreeData(extendNewData, allKeys);
  const newShowData = formatShowTreeData(newData);
  (listRes.data || []).filter((el: any) => el.is_bpart_classification).forEach((el: any) => {
    el.product_type = bpartData?.data?.[0]?.product_type;
  });
  return {
    treeList: listRes.data || [],
    treeData: newShowData,
  };
};

export const getSampleDraftTreeData = async (cpartCode: string, demoType: string) => {
  const cpartRes = await postRecordList({
    app_id: 'master_data',
    model_id: 'md_cpart_product_base_info',
    product_code: cpartCode,
  });
  const cpartData = cpartRes?.data[0];
  const { bd_brand_classification_type_code, bd_brand_classification_number, bd_bpart_product_classification_number: productCode } = cpartData || {};
  const brandType = bd_brand_classification_type_code || '';
  const brandCode = bd_brand_classification_number || '';
  const searchParams: any = {
    app_id: 'master_data',
    model_id: 'md_bbom_template',
    bd_bpart_product_classification_number: productCode,
  };
  // if (brandType) {
  //   searchParams.bd_brand_classification_type_code = brandType;
  // }
  // if (brandCode) {
  //   searchParams.bd_brand_classification_number = brandCode;
  // }
  const res = await postRecordList(searchParams);
  // const mainData = (res?.data || []).find((item: any) => {
  //   return item.bd_brand_classification_type_code === brandType && item.bd_brand_classification_number === brandCode;
  // });
  const mainData = res?.data?.[0];
  // const res = await postRecordList({
  //   app_id: 'master_data',
  //   model_id: 'md_bbom_template',
  //   bd_bpart_product_classification_number: productCode,
  //   bd_brand_classification_type_code: brandType,
  //   bd_brand_classification_number: brandCode,
  // });
  if (mainData) {
    const listData = await getShowTreeData(mainData, productCode, cpartCode, demoType);
    return {
      mainInfo: res.data[0],
      ...listData,
    };
  } else {
    return {
      mainInfo: {},
      treeData: undefined,
      treeList: [],
    };
  }
};

export async function updateBatch({ appId, modelId, data }: any) {
  const [err, res] = await Api({
    method: 'post',
    url: `/api/gateway/metabase/api/v1/${appId}/${modelId}/multiple_update`,
    data,
  });
  return res || {};
}

export const createRecord = async ({
  appId = 'base',
  modelId,
  data,
}: any) => {
  const [err, res] = await Api({
    method: 'post',
    url: `/api/gateway/metabase/compose/namespace/${appId}/module/${modelId}/record`,
    data: {
      records: [],
      labels: '{}',
      click: 'save',
      values: data,
    },
  });
  return res;
};

export const create = async ({ appId = 'base', modelId, data }: any) => {
  const [err, res] = await Api({
    method: 'post',
    url: `/api/gateway/metabase/api/v1/${appId}/${modelId}/create`,
    data,
  });
  return res;
};

export const deleteRecord = async ({ appId, modelId, recordId }: any): Promise<any> => {
  const [err, res] = await Api({
    method: 'delete',
    url: `/api/gateway/metabase/api/v1/${appId}/${modelId}/delete/${recordId}`,
  });
  return res || {};
};

export async function createBatch({ appId, modelId, data }: any) {
  const [err, res] = await Api({
    method: 'post',
    url: `/api/gateway/metabase/api/v1/${appId}/${modelId}/create_batch`,
    data,
  });
  return res;
}
